export const ActionTypes = {
  contactsOthers: 'CONTACTS_OTHERS',
  contactsLost: 'CONTACTS_LOST',
  mailMag: 'MAILMAG',
  campaignMail: 'CAMPAIGNMAIL',
  clearState: 'CLEAR_STATE',
} as const
